import { get } from '@util/xhrAPI'
import { useDispatch, useSelector } from 'react-redux'
import { updateMissions, initMissionFormObject } from '@store/slice/missionSlice'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ROLE_SUPER_ADMIN } from '@router/Routes'
import Buttons from '@ui/elements/Buttons'
import MissionVign from '@scene/window/mission/__partials/MissionVign'
import Alert from '@ui/elements/Alert'
import Div from '@ui/layout/Div'
import TextType from '@ui/inputs/TextType'
import { useNavigate } from 'react-router'


const MissionsList = () => {
  const { missions, mairieMissionFormObject } = useSelector(state => state.mission)
  const dispatch = useDispatch()
  const [t] = useTranslation('common')
  const navigate = useNavigate()
  const [search, setSearch] = useState('')

  const searchMissions = () => {
    const nodes = Object.values(missions)
    if (!search) {
      return nodes
    }

    return nodes.filter(mission => {
      const address = `${mission.mairie.name}, ${mission.city.name},${mission.addressComplement}`
      return mission.missionTitle.toLowerCase().includes(search.toLowerCase())
        || address.toLowerCase().includes(search.toLowerCase())
        || mission.responsibleFullName.toLowerCase().includes(search.toLowerCase())
        || mission.responsibleEmail.includes(search.toLowerCase())
        || mission.id == search
    })
  }

  const renderMissions = () => {
    const missionsList = null !== missions ? searchMissions() : []
    if (null !== missions && missionsList.length) {
      return missionsList.map(mission => <MissionVign mission={mission} key={`mission-${mission.id}`} />)
    }
    return <Alert type='is-info' message={t('messages.empty_list')} />
  }

  useEffect(() => {
    if (null === missions) {
      get(`${import.meta.env.VITE_API_URL}/api/missions`, response => {
        const { code, errors, missions } = response
        if (200 === code) {
          dispatch(updateMissions(missions))
        } else {
          console.error(errors)
        }
      })
    }
    if (mairieMissionFormObject.id) {
      dispatch(initMissionFormObject())
    }
  }, [initMissionFormObject])

  const handleSearchField = (event) => {
    setSearch(event.target.value)
  }

  return (
    <Div cssClass='missions-list'>
      <Buttons buttons={{
        icon: 'icon-add',
        cssClass: 'is-info is-small',
        callback: () => navigate(ROLE_SUPER_ADMIN['createMission']),
        text: t('actions.add')
      }}
      />
      <h2 className='zone-title'>{t('titles.missions_list')}</h2>
      <TextType value={search || ''} onChange={handleSearchField} placeholder={t('labels.search_field_missions')} />
      <Div cssClass='columns is-multiline'>
        {renderMissions()}
      </Div>
    </Div>
  )
}

export default MissionsList